import { Address, DocumentItem } from '../../../../graphql/graphql';
import { discourseDocumentItemType } from '../../Enums/discourseDocumentItemType.const';

export interface DiscourseTravelAddressFormValues {
	street: string;
	descriptiveNumber: string;
	guideNumber: string;
	city: string;
	postCode: string;
}

export interface DiscourseTravelFormValues {
	distanceKm: number | string;
	fromAddress: DiscourseTravelAddressFormValues;
	toAddress: DiscourseTravelAddressFormValues;
}

export interface DiscourseTravelItemExtra {
	distanceKm: number;
	fromAddress: DiscourseTravelAddressFormValues;
	toAddress: DiscourseTravelAddressFormValues;
}

type DiscourseTravelAddressSource = Pick<
	Address,
	'street' | 'descriptiveNumber' | 'guideNumber' | 'city' | 'postCode'
>;

export const mapAddressToDiscourseTravelAddress = (
	address?: DiscourseTravelAddressSource | null,
): DiscourseTravelAddressFormValues => ({
	street: address?.street ?? '',
	descriptiveNumber: address?.descriptiveNumber ?? '',
	guideNumber: address?.guideNumber ?? '',
	city: address?.city ?? '',
	postCode: address?.postCode ?? '',
});

export const findDiscourseTravelAttachment = (
	attachments?: Array<DocumentItem | null | undefined> | null,
) =>
	attachments?.find(
		item => item?.type === discourseDocumentItemType.discourseTravel,
	) ?? null;

export const formatDiscourseTravelDistance = (
	travelItem?: DocumentItem | null,
) => {
	const distanceKm = (travelItem?.extra as DiscourseTravelItemExtra | undefined)
		?.distanceKm;

	return distanceKm != null ? `${distanceKm} km` : '';
};
